import { Suspense } from "react";
import Router from "./routes/Router.tsx";
import { useSignals } from "@preact/signals-react/runtime";
import useAudio from "./real-time/hooks/useAudio.ts";
import "./real-time/hooks/useCalls";

function App() {
  useSignals();
  const { audio } = useAudio();

  let pageConte = <Router />;

  // if  (isError.value.includes("The Code Is Expired Or Wrong")) {
  //   pageConte = <SubscriptionExpired />;
  // }
  // else if (
  //   isError.value.includes("Admin Not Connected") ||
  //   isError.value.includes("Cannot Get Device Info")
  // ) {
  //   pageConte = <AdminIsIdle />;
  // } else
  // if (
  //   isError.value.includes("Admin Removed Your Account!") ||
  //   isError.value.includes("Blocked")
  // ) {
  //   pageConte = <AdminRemovedYou />;
  // }
  // else if (mainInfo.value.country !== "ُEgypt") {
  //   pageConte = <IPOutOfRange />;
  // }

  // <div className="grid place-items-center min-h-screen bg-white/75 fixed inset-0 w-full z-50">
  //   <Loader />
  // </div>

  return (
    <Suspense>
      <audio src="/message-notification.mp3" ref={audio}></audio>

      {pageConte}
    </Suspense>
  );
}

export default App;

// const SubscriptionExpired = () => {
//   return (
//     <div className="fixed z-50 px-8 text-center w-full h-full bg-white bg-opacity-90 flex justify-center items-center flex-col">
//       <IoWarning className="text-9xl text-red-500 bg-white animate-pulse" />
//       <p dir="ltr" className="text-blue-700 font-bold mt-2">
//         Error, the website cannot be used... Please, contact technical support!
//       </p>
//     </div>
//   );
// };

// const AdminIsIdle = () => {
//   return (
//     <div className="fixed z-50 px-8 text-center w-full h-full bg-white flex justify-center items-center flex-col">
//       <img
//         src="/assets/images/client/admin-maintaince.png"
//         alt="admin warning illustration"
//         className="h-[40dvh] object-contain"
//         loading="lazy"
//       />
//       <p dir="ltr" className="text-blue-700 font-bold mt-2">
//         Sorry for the inconvenience, the website is currently under maintenance
//         to improve your experience. We will be back soon. Thank you for your
//         understanding.
//       </p>
//     </div>
//   );
// };

// const AdminRemovedYou = () => {
//   return (
//     <div className="fixed z-50 px-8 text-center w-full h-full bg-white bg-opacity-90 flex justify-center items-center flex-col">
//       <img
//         src="/assets/images/client/admin-warning.jpg"
//         alt="admin warning illustration"
//         className="h-[40dvh]"
//         loading="lazy"
//       />
//       <p dir="ltr" className="text-blue-700 font-bold mt-2">
//         You have been banned from using the site for violating the terms of use.
//       </p>
//     </div>
//   );
// };
